import styled from "styled-components";
import "@fontsource/lexend";
import "@fontsource/bebas-neue";
import "@fontsource/merriweather";
import "@fontsource/montserrat"; 

export const SummaryPageContainer = styled.div`
  background: #282c34;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 16px;
`;

export const SummaryCard = styled.article`
  width: 100%;
  max-width: 980px;
  background: #0f0f10;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.45);
  overflow: hidden;
`;

export const SummaryHeader = styled.header`
  background: radial-gradient(1200px 400px at 10% -10%, rgba(1,45,156,0.35), rgba(255,224,223,0.06) 60%, transparent), #121214;
  padding: 28px 26px 22px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
`;

export const SummaryEyebrow = styled.p`
  margin: 0 0 8px 0;
  font-family: "Lexend";
  font-size: 28px;
  color: #FFE0DF;
  letter-spacing: 0.4px;
`;

export const SummaryTitle = styled.h1`
  margin: 0;
  font-family: "Merriweather";
  font-weight: 600;
  font-size: 28px;
  color: #fff;
`;

export const SummaryIntro = styled.p`
  margin: 0;
  margin-top: 10px;
  color: #dcdcdc;
  font-family: "Lexend";
  font-size: 16px;
`;

export const SummaryIntroText = styled.p`
  margin: 0;
  margin-top: 10px;
  color: #dcdcdc;
  font-family: "Lexend";
  font-size: 16px;
  text-align: center;
`;


export const SummaryBody = styled.div`
  padding: 24px 26px 26px;
  display: flex;
  flex-direction: column;
  gap: 26px; /* spacing between sections */
`;

export const SummarySection = styled.section``;

export const SectionTitle = styled.h2`
  font-family: "Merriweather";
  font-weight: 600;
  color: #fff;
  font-size: 20px;
  margin: 0 0 12px 0;
`;

export const PricePill = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #012D9C;
  color: #FFE0DF;
  font-family: "Lexend";
  font-size: 13px;
  font-weight: 700;
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 18px;
  list-style: disc;
  color: #ececec;
  font-family: "Lexend";
  font-size: 15px;
  line-height: 1.65;

  li + li { margin-top: 6px; }
`;

export const Note = styled.p`
  margin-top: 18px;
  color: #cfcfcf;
  font-family: "Lexend";
  font-size: 20px;
`;
export const NoteTitle = styled.p`
  margin-top: 18px;
  color: #cfcfcf;
  font-family: "Lexend";
  font-size: 20px;
  text-align: center;
`;

export const OptionalText = styled.p`
  margin-top: 18px;
  color: #cfcfcf;
  font-family: "Lexend";
  font-size: 14px;
`;

export const CTABox = styled.div`
  border-radius: 16px;
  background: #474747;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CTAHeading = styled.h3`
  font-family: "Merriweather";
  font-size: 18px;
  color: #fff;
  margin: 0;
  text-align: center;
`;

export const ButtonRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const CTAButton = styled.a`
  text-align: center;
  text-decoration: none;
  font-family: "Lexend";
  font-weight: 700;
  font-size: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #012D9C;
  color: #FFE0DF;
  box-shadow: 0 4px 14px rgba(1,45,156,0.35);
  border: none;
  outline: none;
  appearance: none;
  transition: transform 0.08s ease, opacity 0.2s ease;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
`;

export const SecondaryButton = styled.button`
  appearance: none;
  border: 0;
  cursor: pointer;
  text-align: center;
  font-family: "Lexend";
  font-weight: 700;
  font-size: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #181818;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  transition: transform 0.08s ease, opacity 0.2s ease;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
`;

export const FooterNote = styled.div`
  padding: 18px 26px 28px;
  border-top: 1px solid rgba(255,255,255,0.06);
  color: #d8d8d8;
  font-family: "Lexend";
  font-size: 14px;
`;

export const FallbackBox = styled.div`
  padding: 20px;
  background: #151517;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  color: #eee;
  font-family: "Lexend";
`;